import t from"./setPrototypeOf.js";function o(o,e){o.prototype=Object.create(e.prototype);o.prototype.constructor=o;t(o,e)}export{o as default};
//# sourceMappingURL=inheritsLoose.js.map
